import type { TagPath } from "@/types/dataPointTypes.ts"

export const getTagPathDisplayName = (path: TagPath): string => {
  if (path.tag != undefined) {
    const tagArray = path.tag.split("/")
    return tagArray[tagArray.length - 1]
  } else if (path.driver != undefined) {
    return path.driver
  } else if (path.historyProvider != undefined) {
    return path.historyProvider
  }
  return ""
}
